"use client";

import { ScholarshipController } from "@up/scholarship-form";

export default function ScholarshipPage() {
  return <ScholarshipController />;
}
